import React, { useState } from "react";
import {
  Button,
  Modal,
  TableAdv,
  PageHeader,
  PageTitle,
} from "../../../../../../../../../components";
import {
  dateFormator,
  formatNumber,
  mapTableRows,
} from "../../../../../../../../../utils";
import { formatCurrency } from "../../../../../../../../../utils/stringUtils";
import { exactUTCDate } from "../../../../../../../../../utils/dateFormator";

const UnpaidTimesheetsTwo = ({
  isOpen,
  onClose,
  setShowUnpaid,
  unpaidTimesheetDetailsData,
  handleSelectionChangeUnpaid,
  currentUnpaidIds = [],
  calculateRowDetailsWithRates,
}) => {
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedRowsByClient, setSelectedRowsByClient] = useState({});
  const tableData = [
    {
      jobTitle: "RPA Developer",
      client: "IBM",
      payCycle: "07/29/2024 - 07/31/2024",
      classification: "Standard Time",
      totalHours: "24.00",
      usPayRate: "$49.60",
      indiaPayRate: "$49.60",
      totalAmount: "$6528.00",
      balancedAmount: "6528.00",
    },
    {
      jobTitle: "RPA UI path Developer",
      client: "IBM",
      payCycle: "07/29/2024 - 07/31/2024",
      classification: "Standard Time",
      totalHours: "24.00",
      usPayRate: "$49.60",
      indiaPayRate: "$49.60",
      totalAmount: "$6528.00",
      balancedAmount: "6528.00",
    },
  ];
  const columns = [
    { key: "jobTitle", label: "Job Title" },
    {
      key: "client",
      label: "Client",
    },
    { key: "payCycle", label: "Pay Cycle" },
    { key: "classification", label: "Classification" },
    { key: "totalHours", label: "Total Hours" },
    { key: "usPayRate", label: "US Pay Rate" },
    { key: "indiaPayRate", label: "India Pay Rate" },
    {
      key: "totalAmount",
      label: "Total Amount",
      width: "150px",
      total: true,
      totalRender: (balancedAmount, totals) => {
        return (
          <div>
            Total
            {formatNumber(balancedAmount)}
          </div>
        );
      },
    },
    {
      key: "balancedAmount",
      label: "Balanced Amount",
      width: "150px",
      total: true,
      totalRender: (balancedAmount, totals) => {
        return (
          <div>
            {/* Total : {} */}$ {formatNumber(balancedAmount)}
          </div>
        );
      },
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);

  const MicrosofttableData = [
    {
      jobTitle: "RPA Developer",
      client: "IBM",
      payCycle: "07/29/2024 - 07/31/2024",
      classification: "Standard Time",
      totalHours: "24.00",
      usPayRate: "$49.60",
      indiaPayRate: "$49.60",
      totalAmount: "$6528.00",
      balancedAmount: "6528.00",
    },
    {
      jobTitle: "RPA UI path Developer",
      client: "IBM",
      payCycle: "07/29/2024 - 07/31/2024",
      classification: "Standard Time",
      totalHours: "24.00",
      usPayRate: "$49.60",
      indiaPayRate: "$49.60",
      totalAmount: "$6528.00",
      balancedAmount: "6528.00",
    },
  ];
  const Microsoftcolumns = [
    { key: "jobTitle", label: "Job Title" },
    {
      key: "client",
      label: "Client",
    },
    { key: "payCycle", label: "Pay Cycle" },
    { key: "classification", label: "Classification" },
    { key: "totalHours", label: "Total Hours" },
    { key: "usPayRate", label: "US Pay Rate" },
    { key: "indiaPayRate", label: "India Pay Rate" },
    { key: "totalAmount", label: "Total Amount" },
    { key: "balancedAmount", label: "Balanced Amount" },
  ];

  const mappedRowsMicrosoft = mapTableRows(
    MicrosofttableData,
    Microsoftcolumns,
  );
  const handleSelectionChange = (selectedRowIds, clientId) => {
    // Update selection for this specific client
    setSelectedRowsByClient(prev => ({
      ...prev,
      [clientId]: selectedRowIds
    }));

    // Combine all selections from all clients
    const allSelectedIds = Object.values({
      ...selectedRowsByClient,
      [clientId]: selectedRowIds
    }).flat();

    // Convert to strings for comparison
    const stringIds = allSelectedIds.map(id => String(id));
    
    handleSelectionChangeUnpaid(stringIds);
    console.warn("ids", stringIds);
    console.log("unpaidTimesheetDetailsData", unpaidTimesheetDetailsData);
    
    const filteredTimesheets = unpaidTimesheetDetailsData
      .filter((item) => stringIds.includes(String(item?.uiid)))
      ?.map((row) => {
        const { totalAmount, rateBreakdown, hasMultipleRates } =
          calculateRowDetailsWithRates(row);
        console.log({ totalAmount, rateBreakdown, hasMultipleRates });
        return {
          ...row,
          amounts: {
            ...row.amounts,
            deduction: Number(totalAmount) ? totalAmount : 0,
            rateBreakdown,
          },
        };
      });
    console.log("filteredTimesheets", filteredTimesheets);
    const totalUnpaidTimesheets =
      filteredTimesheets?.reduce(
        (acc, item) =>
          acc +
          item?.dailyEntries?.reduce(
            (acc2, item2) => acc2 + (item2.st || 0),
            0,
          ) *
            (item?.placementId?.payments[item?.placementId?.payments.length - 1]
              ?.payRate?.payRatePerHour || 0),
        0,
      ) || 0;
    setTotalAmount(totalUnpaidTimesheets || 0);
  };
  return (
    <Modal
      title={"UNPAID TIMESHEET DETAILS "}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-6xl"
    >
      <div>
        {Object.entries(
          unpaidTimesheetDetailsData.reduce((acc, item) => {
            const id = item?.clientId?.uiid;
            if (!acc[id]) acc[id] = [];
            acc[id].push(item);
            return acc;
          }, {}),
        ).map(([clientId, entries], index) => {
          const copyEntries = [...entries];
          const tableData = copyEntries?.map((item) => ({
            id: item?.uiid, // Important for TableAdv
            uiid: item?.uiid,
            jobTitle: item?.placementId?.jobInfo?.jobTitle || "-",
            client: item?.clientId?.businessName || "-",
            payCycle:
              item?.period?.from && item?.period?.to
                ? `${exactUTCDate(
                    item?.period?.from,
                  )} - ${exactUTCDate(item?.period?.to)}`
                : "-",
            classification: "Standard Time",
            totalHours: item?.dailyEntries?.reduce(
              (acc, item) => acc + item.st,
              0,
            ),
            // usPayRate:
            //   item?.placementId?.payments[
            //     item?.placementId?.payments.length - 1
            //   ]?.payRate?.payRatePerHour || 0,
            usPayRate: (item?.placementId?.payments?.[
              item?.placementId?.payments?.length - 1
            ]?.payRate?.subPercent > 0
              ? ((item?.placementId?.payments?.[
                  item?.placementId?.payments?.length - 1
                ]?.payRate?.payRatePerHour || 0) *
                  100) /
                item?.placementId?.payments?.[
                  item?.placementId?.payments?.length - 1
                ]?.payRate?.subPercent
              : item?.placementId?.payments?.[
                  item?.placementId?.payments?.length - 1
                ]?.payRate?.payRatePerHour || 0
            )?.toFixed(2),
            indiaPayRate: item?.placementId?.payments?.[
              item?.placementId?.payments?.length - 1
            ]?.payRate?.subPercent
              ? item?.placementId?.payments?.[
                  item?.placementId?.payments?.length - 1
                ]?.payRate?.payRatePerHour
              : "-" || "-",
            totalAmount: (
              <div>
                {(() => {
                  try {
                    if (!item?.dailyEntries?.length)
                      throw new Error("Missing daily entries data");
                    const total = item.dailyEntries.reduce((t, i) => {
                      if (typeof i.st !== "number")
                        throw new Error(
                          "Invalid type for item.st. Expected number, got " +
                            typeof i.st,
                        );
                      return (
                        t +
                        i.st *
                          (item?.placementId?.payments[
                            item?.placementId?.payments.length - 1
                          ]?.payRate?.payRatePerHour || 0)
                      );
                    }, 0);
                    return total.toFixed(2);
                  } catch (e) {
                    return "Error: " + e.message;
                  }
                })()}
              </div>
            ),
            balancedAmount: (
              <div>
                {(() => {
                  try {
                    if (!item?.dailyEntries?.length)
                      throw new Error("Missing daily entries data");
                    const total = item?.dailyEntries.reduce((t, i) => {
                      if (typeof i.st !== "number")
                        throw new Error(
                          "Invalid type for item.st. Expected number, got " +
                            typeof i.st,
                        );
                      return (
                        t +
                        i.st *
                          (item?.placementId?.payments[
                            item?.placementId?.payments.length - 1
                          ]?.payRate?.payRatePerHour || 0)
                      );
                    }, 0);
                    return (total.toFixed(2) - (item?.amounts?.paid || 0).toFixed(2));
                  } catch (e) {
                    return "Error: " + e.message;
                  }
                })()}
              </div>
            ),
          }));
          const rows = mapTableRows(tableData || [], columns);
          const clientName = entries[0]?.clientId?.businessName || "-";
          return (
            <div key={clientId} className="mb-6">
              <PageHeader
                Section={
                  <div className="flex mb-3">
                    <PageTitle title={`Client: ${clientName || "-"}`} />
                  </div>
                }
              />
              <div className="max-h-[400px] overflow-y-scroll">
                <TableAdv
                  showCheckbox
                  onSelectionChange={(selectedRowIds) => 
                    handleSelectionChange(selectedRowIds, clientId)
                  }
                  defaultSelectedRows={selectedRowsByClient[clientId] || currentUnpaidIds}
                  limit={1000}
                  rows={rows}
                  columns={columns}
                  hideToolBar
                  toolbarRight={{
                    search: false,
                    filter: false,
                    download: false,
                  }}
                  tableId={`unpaid-timesheets-${clientId}`}
                />
              </div>
            </div>
          );
        })}
        <div className="flex items-center justify-between">
          <div>Total Unpaid Timesheets: {formatCurrency(totalAmount)}</div>
          <div className="flex justify-end mt-6 gap-4 items-end ">
            <Button
              title="Cancel"
              variant={"outlined"}
              onClick={() => {
                onClose();
              }}
            />
            <Button
              title="Submit"
              onClick={() => {
                // setShowUnpaid(true);
                onClose();
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UnpaidTimesheetsTwo;